module.exports = __webpack_public_path__ + "img/darkGreenPencil.f4564148.svg";